<script lang="ts">
    import src from './Icons/svg/refresh_24dp_FILL0_wght400_GRAD0_opsz24.svg';
    import WhiteColor from './WhiteColor.svelte';
    export let disabled: boolean = false;
    export let showIcon: boolean = true;
    export let title: string = '';
</script>

<button class="btn-main dont-break" on:click {disabled} {title}>
    <WhiteColor>
        <span
            style="filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(152deg) brightness(103%) contrast(103%); width:24px; height: 24px;"
        >
            <img {src} alt="" />
        </span>
    </WhiteColor>
</button>

<style>
    .btn-main {
        background-color: #4978e2;
        color: white;
        border: none;
        cursor: pointer;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        line-height: 11px;
        min-width: 22px;
    }
    .btn-main img {
        height: 18px;
        width: 18px;
    }
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }
</style>
